import { render, staticRenderFns } from "./table-client-rules.vue?vue&type=template&id=4e44af9a&scoped=true&"
import script from "./table-client-rules.vue?vue&type=script&lang=js&"
export * from "./table-client-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e44af9a",
  null
  
)

export default component.exports